import { getStableJson } from './getStableJson';

export function stringifyJSON(value: unknown): string | undefined {
	try {
		return JSON.stringify(value, getStableJson, '\t');
	} catch {
		return undefined;
	}
}
